import { create } from 'zustand';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { checkDevicesPayment, getPayments } from '../../../api/api';

export const PAYMENT_STATUS = {
  pending: {
    label: 'Ожидает оплаты',
    className: 'text-orange-500',
    icon: <HourglassEmptyIcon fontSize="small" className="text-orange-500" />,
  },
  waiting_for_capture: {
    label: 'Ожидает подтверждения',
    className: 'text-orange-500',
    icon: <HourglassTopIcon fontSize="small" className="text-orange-500" />,
  },
  succeeded: {
    label: 'Успешно',
    className: 'text-green-600',
    icon: <CheckCircleIcon fontSize="small" className="text-green-600" />,
  },
  canceled: {
    label: 'Отменен',
    className: 'text-red-500',
    icon: <CancelIcon fontSize="small" className="text-red-500" />,
  },
};

const STATUS_OPTIONS = Object.entries(PAYMENT_STATUS).map(([value, { label, icon }]) => ({ value, name: label, icon }));
const INITIAL_PAYMENT_MODAL_STATE = {
  showPaymentModal: false,
  isCheckingPayment: false,
  paymentData: null,
  isPaymentRequired: null,
  paymentModalError: '',
};

export const usePaymentsStore = create((set) => ({
  data: [],
  total: 0,
  isLoading: false,
  error: null,
  statusOptions: STATUS_OPTIONS,
  ...INITIAL_PAYMENT_MODAL_STATE,

  fetchPayments: async ({ page, count, searchParams } = {}) => {
    set({ isLoading: true, error: null });

    await getPayments({
      page,
      count,
      searchParams,
      dataCb: (res) => {
        set({
          data: res?.items ?? [],
          total: res?.count ?? 0,
          isLoading: false,
        });
      },
      errCb: (err) => {
        set({ error: err, isLoading: false });
      },
    });
  },

  openPaymentModal: async () => {
    set({
      ...INITIAL_PAYMENT_MODAL_STATE,
      showPaymentModal: true,
      isCheckingPayment: true,
    });

    try {
      const response = await checkDevicesPayment();

      if (!response?.payment) {
        set({ isPaymentRequired: false });
        return;
      }

      set({
        isPaymentRequired: true,
        paymentData: response,
      });
    } catch (err) {
      const errorText = err?.response?.data?.error || err?.response?.data?.details?.[0] || 'Не удалось подготовить оплату';
      set({ paymentModalError: errorText });
    } finally {
      set({ isCheckingPayment: false });
    }
  },

  closePaymentModal: () => {
    set({
      ...INITIAL_PAYMENT_MODAL_STATE,
    });
  },
}));
